/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_Boundary_Server_UnavailableInputs */

const nl_common_error_boundary_server_unavailable = /** @type {(inputs: Common_Error_Boundary_Server_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De server is even niet bereikbaar. Probeer het over een moment opnieuw.`)
};

/**

* @param {Common_Error_Boundary_Server_UnavailableInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_error_boundary_server_unavailable = /** @type {((inputs?: Common_Error_Boundary_Server_UnavailableInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_Boundary_Server_UnavailableInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_error_boundary_server_unavailable(inputs)
});
export { common_error_boundary_server_unavailable as "common.error_boundary_server_unavailable" }